import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state:{
    nickName:localStorage.getItem("nickName") || '',
    addressDetail:{},
    user: JSON.parse(localStorage.getItem("user")) ||{},
    cartCount:localStorage.getItem("cartCount") || 0,
    checkedGoodsList:JSON.parse(localStorage.getItem("checkedGoodsList")) || [],
    providerId: localStorage.getItem("providerId") || ''
  },
  mutations:{
    updateNickName(state,nickName){
      localStorage.setItem('nickName',nickName);
      state.nickName = nickName;
    },
    updateAddressDetail(state,addressDetail){
      state.addressDetail = addressDetail;
    },
    updateUserInfo(state,user){
      localStorage.setItem('user', JSON.stringify(user));
      state.user = user;
    },
    updateCartCount(state,cartCount){
      localStorage.setItem('cartCount',cartCount);
      state.cartCount = cartCount;
    },
    updateCheckedGoodsList(state,checkedGoodsList){
      localStorage.setItem('checkedGoodsList',JSON.stringify(checkedGoodsList));
      state.checkedGoodsList = checkedGoodsList;
    },
    updateProviderId(state, providerId){
      localStorage.setItem('providerId', providerId);
      state.providerId = providerId;
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js